import {useMemo} from 'react';
import {v4 as uuidv4} from 'uuid';

//This is introduced in React 18. Here's a custom hook to use in the meantime.
export function useId(): string {
	return useMemo(() => uuidv4(), []);
}
